import DropdownMenu from '@/src/components/Commons/Controllers/DropdownMenu';
import SearchString from '@/src/components/Commons/Controllers/SearchString';
import { IFundDetailsForUsers } from '@/src/hooks/useFundDetailsForHome';
import { IFundListForUsers } from '@/src/hooks/useFundListForHome';
import useWindowSize from '@/src/hooks/useResponsive';
import FundsTableHome from './Table/TableHome';
import styles from './FundList.module.scss';
import Pagination from '@/src/components/Commons/Controllers/Pagination/Pagination';

type FundListProps = {};
export default function FundList(props: FundListProps & IFundDetailsForUsers & IFundListForUsers) {
    const { isLoadingList, list, handlePageChange, currentPage, totalPages, totalItems, searchString, setSearchString, typeFilter, typeFilterSelected, setTypeFilterSelected, id } = props;

    //--------------------------------------
    const { width } = useWindowSize();
    const isTablet = width < 1366;
    const isMobile = width <= 480;
    //--------------------------------------

    return (
        <main className={styles.fundList}>
            {totalItems !== undefined && totalItems > 1 && (
                <section className={styles.findSection}>
                    <SearchString isLoadingList={isLoadingList} searchString={searchString} setSearchString={setSearchString} />
                    <DropdownMenu
                        name={'From'}
                        itemReact={(item) => {
                            return item ?? null;
                        }}
                        items={typeFilter}
                        selected={typeFilterSelected}
                        setSelected={setTypeFilterSelected}
                        styles={styles}
                        className={'filterSection'}
                        swShowTitleInSelected={true}
                        swCloseAutomatically={false}
                    />
                </section>
            )}
            <section className={styles.tableSection}>
                <FundsTableHome funds={list} isTablet={isTablet} isMobile={isMobile} isLoading={isLoadingList} id={id} />
                <div className={styles.paginationSection}>
                    <Pagination totalPages={totalPages} currentPage={currentPage} handlePageChange={handlePageChange} />
                </div>
            </section>
        </main>
    );
}
